import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import { ModalContext } from 'App';
import { get, getJson } from 'session';
import PropTypes from 'prop-types';
import * as c from '../constant';

function ViewFaasModal({ data }) {
  const setModal = useContext(ModalContext);
  const [iframeKey, setIframeKey] = useState(1);

  const url = c.FAAS_URL.replace('{id}', _.get(data, 'id'));

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const token = get('token') || '';
  const authProfile = getJson('profile') || {};

  const src = `${
    process.env.REACT_APP_WS
  }${url}?bearer_token=${token}&email=${_.get(authProfile, 'email')}`;

  useEffect(() => {
    setIframeKey(_.random(1, 1000));
  }, []);

  return (
    <Modal.Body>
      <form>
        <div className="row">
          <div className="col-12">
            <div className="row">
              <div className="col-12">
                <iframe
                  key={iframeKey}
                  style={{ width: '100%', height: 600, border: 'none' }}
                  title="FAAS"
                  src={src}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-center align-items-center">
          <button type="button" onClick={closeModal} className="btn btn-dark ">
            <span className="font-weight-bold">Close</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

ViewFaasModal.defaultProps = {
  data: {},
};

ViewFaasModal.propTypes = {
  data: PropTypes.instanceOf(Object),
};

const enhance = _.flowRight([withForm, withRouter]);

export default enhance(ViewFaasModal);
